/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Lastactivity1Inputs */

const en_titles_lastactivity1 = /** @type {(inputs: Titles_Lastactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last activity`)
};

/**
* | output |
* | --- |
* | "Last activity" |
*
* @param {Titles_Lastactivity1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_lastactivity1 = /** @type {((inputs?: Titles_Lastactivity1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Lastactivity1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_lastactivity1(inputs)
});
export { titles_lastactivity1 as "titles_lastActivity" }